import React from 'react';
import { salesPageData } from '../data/salesPageData';
const PAINS = [{
  n: 1,
  title: 'Buscás más de lo que fabricás',
  text: 'Pasás horas tratando de encontrar un proyecto suficientemente claro para empezar.'
}, {
  n: 2,
  title: 'Tenés ideas, pero no medidas',
  text: 'Encontrás muebles increíbles, pero nadie explica cómo llevarlos a la realidad.'
}, {
  n: 3,
  title: 'Improvisás',
  text: 'Cuando falta información terminás tomando decisiones sobre la marcha.'
}, {
  n: 4,
  title: 'Desperdiciás material',
  text: 'Una pieza mal medida puede significar comprar material nuevamente.'
}, {
  n: 5,
  title: 'No sabés qué fabricar después',
  text: 'Terminás un proyecto y volvés otra vez al punto cero.'
}, {
  n: 6,
  title: 'Todo está desparramado',
  text: 'Fotos. Links. Videos. Capturas. PDFs. Tutoriales. Pero ninguna biblioteca central.'
}, {
  n: 7,
  title: 'No sabés cuánto cobrar',
  text: 'Cuando aparece un cliente, materiales, mano de obra, gastos y margen empiezan a mezclarse.'
}, {
  n: 8,
  title: 'Postergás',
  text: 'Tenés ganas de empezar, pero tanta información termina generando más dudas que acción.'
}];
export function PainSection() {
  return <section className="bg-[#F8F3EA] text-[#111111]" aria-labelledby="pain-title" data-id="element-225" data-mp="5fkfp1s4s258">
      <div className="mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-226" data-mp="5dgcyn5yx96j">
        <div className="mx-auto max-w-3xl text-center" data-id="element-227" data-mp="hix0hyma4ua">
          <p className="font-display text-[10px] font-extrabold uppercase tracking-[0.22em] text-[#E96800]" data-id="element-228" data-mp="38vztisfaaqli">
            El punto de partida
          </p>
          <h2 id="pain-title" className="reveal mt-4 font-display text-2xl font-black uppercase leading-[1.1] tracking-tight sm:text-4xl" data-id="element-229" data-mp="33vdbbq8y2pfz">
            Tenés ganas de fabricar.
            <span className="mt-1 block text-[#3A2416]" data-id="element-230" data-mp="3du1ghoftza29">
              Pero entre la idea y el primer corte aparece el caos.
            </span>
          </h2>
        </div>

        <div className="mx-auto mt-10 grid max-w-5xl items-center gap-8 lg:grid-cols-[1.05fr_1fr]" data-id="element-231" data-mp="2l7qficobb74x">
          <div className="reveal space-y-4 text-[15px] leading-relaxed text-[#111111]/75 sm:text-base" data-id="element-232" data-mp="p4lmwtpguktb">
            <p data-id="element-233" data-mp="u1vd4bkoj0i7">
              Ves un mueble que te gusta. Guardás la foto. Después buscás un tutorial.
              Después otro.
            </p>
            <p className="font-semibold text-[#111111]" data-id="element-234" data-mp="yvzkgvxuxajt">
              Abrís YouTube. Pinterest. Instagram. Google.
            </p>
            <p data-id="element-235" data-mp="65hhrw11pb6x">
              Encontrás una medida acá y otra allá. Y algo que parecía simple termina
              convirtiéndose en horas buscando información antes de siquiera tocar la
              madera.
            </p>
          </div>
          <img src={salesPageData.images.plans} alt="Planos de muebles impresos sobre un banco de trabajo junto a un metro, una escuadra y un lápiz de carpintero" className="reveal w-full rounded-xl border border-[#111111]/10 object-cover shadow-[0_20px_50px_-25px_rgba(17,17,17,0.5)]" loading="lazy" width={1200} height={675} data-id="element-236" data-mp="f430br6ioq7p" />
        </div>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-237" data-mp="25njkam1j4duf">
          {PAINS.map(pain => <li key={pain.n} className="reveal rounded-xl border border-[#111111]/10 bg-white p-5 transition-all duration-200 hover:-translate-y-1 hover:border-[#E96800]/40 hover:shadow-[0_16px_40px_-24px_rgba(17,17,17,0.45)]" data-id="element-238" data-mp="20oq3ajn1a4pi">
              <p className="font-numeric text-xs font-bold uppercase tracking-[0.18em] text-[#E96800]" data-id="element-239" data-mp="1rx7ood5qjwyj">
                Dolor #{pain.n}
              </p>
              <h3 className="mt-2 font-display text-sm font-extrabold uppercase leading-snug tracking-tight text-[#111111]" data-id="element-240" data-mp="1mv8o1b1dre5a">
                {pain.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-[#111111]/65" data-id="element-241" data-mp="1cznorknp4rz8">
                {pain.text}
              </p>
            </li>)}
        </ul>

        <div className="reveal mx-auto mt-14 max-w-2xl rounded-2xl border border-[#3A2416]/15 bg-[#EFEDE8] p-7 text-center sm:p-10" data-id="element-242" data-mp="37cwq2p63976e">
          <p className="font-display text-lg font-extrabold uppercase tracking-tight text-[#3A2416] sm:text-2xl" data-id="element-243" data-mp="33cwd78yn141g">
            ¿Te suena?
          </p>
          <div className="mt-4 space-y-1.5 text-[15px] leading-relaxed text-[#111111]/75 sm:text-base" data-id="element-244" data-mp="3fdulynasmybw">
            <p data-id="element-245" data-mp="31e3bgwjhk02n">Querías fabricar. Terminaste investigando.</p>
            <p data-id="element-246" data-mp="31dtm9b69lwy0">Querías empezar. Terminaste guardando otro video.</p>
            <p data-id="element-247" data-mp="35enak5nmddrf">Querías un plano. Terminaste con 14 pestañas abiertas.</p>
          </div>
        </div>

        <p className="reveal mx-auto mt-12 max-w-3xl text-center font-display text-xl font-black uppercase leading-tight tracking-tight text-[#111111] sm:text-3xl" data-id="element-248" data-mp="2rn8qrwlw18jb">
          ¿Y si a partir de ahora no tuvieras que empezar cada proyecto{' '}
          <span className="text-[#E96800]" data-id="element-249" data-mp="2ho14ul1385kl">desde cero?</span>
        </p>
      </div>
    </section>;
}